import { defaultContent } from '../data/mock';

// Base URL of the site that hosts the Netlify Functions. For the consumer site
// the functions are same-origin, so this stays empty and we use relative paths.
// (The standalone admin tool points at the consumer site's absolute URL instead.)
const API_BASE = process.env.REACT_APP_API_BASE || '';

export const CONTENT_ENDPOINT = `${API_BASE}/.netlify/functions/content`;

const isObject = (v) => v && typeof v === 'object' && !Array.isArray(v);

// Deep-merge `override` onto `base`. Arrays and primitives from `override`
// replace the base value wholesale; nested objects are merged key by key so a
// partial saved document still falls back to defaults for any missing field.
export function deepMerge(base, override) {
  if (!isObject(override)) return override === undefined ? base : override;
  const out = Array.isArray(base) ? [...base] : { ...base };
  for (const key of Object.keys(override)) {
    out[key] = isObject(base?.[key]) && isObject(override[key])
      ? deepMerge(base[key], override[key])
      : override[key];
  }
  return out;
}

// Fetch the admin-edited content and merge it over the defaults. Any failure
// (offline, function not deployed, empty store) silently falls back to defaults.
export async function fetchContent() {
  try {
    const res = await fetch(CONTENT_ENDPOINT, { headers: { Accept: 'application/json' } });
    if (!res.ok) return defaultContent;
    const data = await res.json();
    if (!data || typeof data !== 'object') return defaultContent;
    return deepMerge(defaultContent, data);
  } catch {
    return defaultContent;
  }
}
